{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-mathematik-kongruenz-dreiecke-vektoren",
  "version": "2026.08.1",
  "title": "Mathematik 7 I: Geometrie Vertiefung – Die 4 Kongruenzsätze, Transversalen und Vektoren (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Mathematik 7 (Wahlpflichtfächergruppe I): Die 4 Kongruenzsätze (SSS, SWS, WSW, Ssw), Besondere Linien im Dreieck (Mittelsenkrechte, Winkelhalbierende, Seitenhalbierende, Höhen) und Vektorrechnung (Parallelverschiebung, Gegenvektor, Addition).",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:10:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/mathematik",
      "checked": "2026-08-15",
      "label": "Realschule Mathematik 7 (Wahlpflichtfächergruppe I), Lernbereich Kongruenz und Vektoren"
    }
  ],
  "atoms": [
    {
      "id": "01K4M7K0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4M7K0000000000000000A01",
      "namespace": "mathematik-geometrie",
      "slug": "kongruenzsaetze-dreiecke-sss-sws-wsw-ssw",
      "title": "Kongruenz von Dreiecken: Die 4 Kongruenzsätze (SSS, SWS, WSW, Ssw) und Dreieckskonstruktion",
      "domain": "schule/mathematik/geometrie",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q395",
          "target_label": "Congruence (geometry)",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb2",
          "topic_title": "Kongruenz und Dreieckslehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7K0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Bedingung muss beim Kongruenzsatz SsW (großes S, kleines s, Winkel W) zwingend erfüllt sein, damit das Dreieck eindeutig konstruierbar ist?",
          "concept": "Der gegebene Winkel muss der LÄNGEREN der beiden gegebenen Seiten gegenüberliegen",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Winkel liegt der längeren Seite gegenüber (Ssw)",
              "Winkel liegt der kürzeren Seite gegenüber"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7K0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Definiere den Begriff der geometrischen Kongruenz (Deckungsgleichheit $\\cong$: zwei Figuren stimmen in allen Seitenlängen und Winkelmaßen überein und können durch Kongruenzabbildungen aufeinander abgebildet werden), formuliere die 4 Kongruenzsätze für Dreiecke (1. SSS: drei Seiten, 2. SWS: zwei Seiten und der von ihnen eingeschlossene Winkel, 3. WSW bzw. SWW: eine Seite und zwei Winkel, 4. Ssw: zwei Seiten und der Gegenwinkel der größeren Seite) und begründe, warum 'WWW' (drei Winkel) KEIN Kongruenzsatz ist (sondern nur Ähnlichkeit $\\sim$ garantiert).",
          "concept": "Kongruenz: Deckungsgleichheit; 4 Sätze: SSS, SWS, WSW, Ssw; WWW ist kein Kongruenzsatz, weil Dreiecke mit identischen Winkeln maßstäblich vergrößert/verkleinert sein können (Ähnlichkeit).",
          "sample_solution": "1. Definition der Kongruenz (Deckungsgleichheit): - Zwei ebene geometrische Figuren $F_1$ und $F_2$ heißen **kongruent ($F_1 \\cong F_2$)**, wenn sie in Form und Größe exakt übereinstimmen. - Sie können durch **Kongruenzabbildungen (Achsenspiegelung, Punktspiegelung, Drehung, Parallelverschiebung)** lückenlos zur Deckung gebracht werden. 2. Die 4 Kongruenzsätze für Dreiecke: - Zwei Dreiecke $ABC$ und $A'B'C'$ sind zueinander kongruent, wenn sie übereinstimmen in:   * **1. SSS-Satz (Seite-Seite-Seite)**: In allen drei Seitenlängen ($a=a', b=b', c=c'$). Voraussetzung: Dreiecksungleichung $a+b > c$ muss erfüllt sein!   * **2. SWS-Satz (Seite-Winkel-Seite)**: In zwei Seitenlängen und dem **von ihnen eingeschlossenen Zwischenwinkel** (z. B. $a, b$ und $\\gamma$).   * **3. WSW- / SWW-Satz (Winkel-Seite-Winkel)**: In einer Seitenlänge und zwei Winkeln (da der dritte Winkel wegen $\\alpha+\\beta+\\gamma=180^\\circ$ eindeutig festliegt).   * **4. Ssw-Satz (Seite-Seite-Winkel)**: In zwei Seitenlängen und demjenigen Winkel, der der **längeren der beiden Seiten gegenüberliegt** ($a > b$ und $\\alpha$). Liegt der Winkel der kürzeren Seite gegenüber, existieren 2 verschiedene Dreiecke (keine Eindeutigkeit!). 3. Warum ist 'WWW' kein Kongruenzsatz?: - Stimmen zwei Dreiecke in allen 3 Innenwinkeln überein (z. B. $30^\\circ, 60^\\circ, 90^\\circ$), so haben sie zwar dieselbe Gestalt, können aber völlig unterschiedliche Seitenlängen und Flächeninhalte besitzen (z. B. winziges Geodreieck vs. riesiges Wand-Geodreieck). - Dies begründet nur **Ähnlichkeit ($F_1 \\sim F_2$)**, nicht Kongruenz!"
        }
      ]
    },
    {
      "id": "01K4M7K0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4M7K0000000000000000A02",
      "namespace": "mathematik-geometrie",
      "slug": "besondere-linien-dreieck-mittelsenkrechte-in-umkreis-schwerpunkt",
      "title": "Transversalen im Dreieck: Mittelsenkrechte (Umkreis), Winkelhalbierende (Inkreis) und Schwerpunkt",
      "domain": "schule/mathematik/geometrie",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4M7K0000000000000000A01",
          "type": "hard",
          "rationale": "Dreieckseigenschaften bauen auf Kongruenzsätzen und Konstruktionen auf."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q395",
          "target_label": "Triangle centers",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb2",
          "topic_title": "Kongruenz und Dreieckslehre",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7K0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "In welchem Schnittpunkt liegt der Mittelpunkt des **Umkreises** (Kreis, der durch alle 3 Eckpunkte $A, B, C$ des Dreiecks verläuft)?",
          "concept": "Im Schnittpunkt $M_U$ der drei Mittelsenkrechten $m_a, m_b, m_c$",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Schnittpunkt der Mittelsenkrechten",
              "Schnittpunkt der Winkelhalbierenden"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7K0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Charakterisiere die 4 ausgezeichneten Punkte und Transversalen des Dreiecks: 1. **Mittelsenkrechte ($m_a, m_b, m_c$)**: Stehen senkrecht auf den Seitenmitten; ihr Schnittpunkt $U$ ist der Mittelpunkt des **Umkreises** (Radius $r=UA=UB=UC$), 2. **Winkelhalbierende ($w_\\alpha, w_\\beta, w_\\gamma$)**: Halbieren die Innenwinkel; ihr Schnittpunkt $I$ ist der Mittelpunkt des **Inkreises** (berührt alle 3 Dreiecksseiten von innen), 3. **Seitenhalbierende ($s_a, s_b, s_c$)**: Verbinden Eckpunkte mit gegenüberliegenden Seitenmitten; schneiden sich im **Schwerpunkt $S$**, der jede Seitenhalbierende im Verhältnis **$2:1$** (vom Eckpunkt aus) teilt, 4. **Höhen ($h_a, h_b, h_c$)**: Stehen senkrecht auf den Seiten durch den gegenüberliegenden Eckpunkt; schneiden sich im **Höhenschnittpunkt $H$**.",
          "concept": "4 Besondere Punkte: Mittelsenkrechte -> Umkreismittelpunkt U; Winkelhalbierende -> Inkreismittelpunkt I; Seitenhalbierende -> Schwerpunkt S (Teilverhältnis 2:1); Höhen -> Höhenschnittpunkt H.",
          "sample_solution": "1. Die 4 klassischen Transversalen und Schnittpunkte im Dreieck: - **1. Mittelsenkrechten und der Umkreis**:   * **Konstruktion**: Senkrechte Geraden im jeweiligen Mittelpunkt der Dreiecksseiten $a, b, c$.   * **Eigenschaft**: Jeder Punkt auf einer Mittelsenkrechten ist von den beiden Endpunkten der Strecke gleich weit entfernt.   * **Schnittpunkt $U$**: Schnittpunkt aller drei Mittelsenkrechten; bildet das Zentrum des **Umkreises**, der exakt durch alle 3 Ecken $A, B$ und $C$ verläuft (Radius $r_U = |UA| = |UB| = |UC|$). - **2. Winkelhalbierenden und der Inkreis**:   * **Konstruktion**: Halbierungsstrahlen der drei Innenwinkel $\\alpha, \\beta, \\gamma$.   * **Eigenschaft**: Jeder Punkt auf einer Winkelhalbierenden hat zu den beiden anliegenden Dreiecksseiten denselben senkrechten Abstand.   * **Schnittpunkt $I$**: Schnittpunkt aller drei Winkelhalbierenden; bildet das Zentrum des **Inkreises**, der alle drei Seiten $a, b, c$ von innen berührt (Radius $r_I$). - **3. Seitenhalbierenden und der Schwerpunkt**:   * **Konstruktion**: Strecken von einem Eckpunkt zur Mitte der gegenüberliegenden Dreiecksseite.   * **Schnittpunkt $S$ (Schwerpunkt)**: Physikalischer Massenmittelpunkt einer homogenen Dreiecksplatte.   * **Teilungsverhältnis**: Der Schwerpunkt $S$ teilt jede Seitenhalbierende im Verhältnis **$2 : 1$** (der längere Abschnitt liegt stets an der Dreiecksecke: $|AS| : |SM_a| = 2:1$). - **4. Höhen und der Höhenschnittpunkt**:   * **Konstruktion**: Das vom Eckpunkt auf die gegenüberliegende Seite gefällte Lot.   * **Schnittpunkt $H$**: Schnittpunkt aller drei Höhenlinien (liegt bei spitzwinkligen Dreiecken im Inneren, beim rechtwinkligen Dreieck exakt im Scheitel des rechten Winkels, bei stumpfwinkligen Dreiecken außerhalb)."
        }
      ]
    },
    {
      "id": "01K4M7K0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4M7K0000000000000000A03",
      "namespace": "mathematik-vektoren",
      "slug": "vektoren-in-der-ebene-parallelverschiebung-koordinaten",
      "title": "Vektoren in der Ebene: Pfeilklassen, Koordinatendarstellung, Gegenvektor und Vektoraddition",
      "domain": "schule/mathematik/vektoren",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q395",
          "target_label": "Euclidean vector",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "mathematik",
          "topic_code": "lb3",
          "topic_title": "Parallelverschiebung und Vektoren",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4M7K0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie lauten die Koordinaten des Vektors $\\vec{v} = \\vec{AB}$ von Punkt $A(2|1)$ zum Bildpunkt $B(7|4)$ nach der 'Spitze-minus-Schaft'-Regel?",
          "concept": "$\\vec{AB} = \\begin{pmatrix} 7-2 \\\\ 4-1 \\end{pmatrix} = \\begin{pmatrix} 5 \\\\ 3 \\end{pmatrix}$",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Vektor (5 | 3)",
              "Vektor (9 | 5)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4M7K0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre den Vektorbegriff der bayerischen Realschulmathematik: 1. Vektor als Menge aller parallelen, gleich langen und gleich gerichteten Pfeile (Repräsentant einer Parallelverschiebung), 2. Berechnung des Verbindungsvektors zweier Punkte $A(x_A|y_A)$ und $B(x_B|y_B)$ über die Regel **'Spitze minus Schaft'**: $\\vec{AB} = \\begin{pmatrix} x_B - x_A \\\\ y_B - y_A \\end{pmatrix}$, 3. Der **Gegenvektor** $-\\vec{v} = \\begin{pmatrix} -v_x \\\\ -v_y \\end{pmatrix}$ (gleiche Länge und Richtung, entgegengesetzte Orientierung), 4. **Vektoraddition (Hintereinanderausführung)**: $\\vec{u} + \\vec{w} = \\begin{pmatrix} u_x + w_x \\\\ u_y + w_y \\end{pmatrix}$ und berechne für $P(-3|4)$, $\\vec{v} = \\begin{pmatrix} 6 \\\\ -2 \\end{pmatrix}$ und $\\vec{w} = \\begin{pmatrix} -1 \\\\ 5 \\end{pmatrix}$ den Bildpunkt $P'$ nach Verschiebung um $\\vec{v}$ sowie den Summenvektor $\\vec{s} = \\vec{v} + \\vec{w}$.",
          "concept": "Vektorrechnung: Vektor = Pfeilklasse (Länge, Richtung, Orientierung); Spitze minus Schaft; Gegenvektor kehrt Vorzeichen um; Vektoraddition komponentenweise; $P' = P + \\vec{v} = (-3+6 | 4-2) = (3|2)$; $\\vec{s} = \\vec{v}+\\vec{w} = \\begin{pmatrix} 6-1 \\\\ -2+5 \\end{pmatrix} = \\begin{pmatrix} 5 \\\\ 3 \\end{pmatrix}$.",
          "sample_solution": "1. Das Vektorkonzept in der 2D-Ebene: - **Definition**: Ein **Vektor $\\vec{v}$** ist die mathematische Beschreibung einer **Parallelverschiebung**. Er fasst alle Pfeile zusammen, die:   * 1. **dieselbe Länge (Betrag)**,   * 2. **dieselbe Richtung (Parallelität)** und   * 3. **dieselbe Orientierung (Pfeilspitze)** besitzen (**Pfeilklasse**). 2. Grundrechenarten mit Vektoren: - **1. Berechnung aus zwei Punkten ('Spitze minus Schaft')**:   * Ein Pfeil startet im Schaft $A(x_A|y_A)$ und endet in der Spitze $B(x_B|y_B)$:   $$\\vec{AB} = \\begin{pmatrix} x_B - x_A \\\\ y_B - y_A \\end{pmatrix}$$ - **2. Der Gegenvektor ($-\\vec{v}$)**:   * Verschiebt exakt um dieselbe Strecke in die entgegengesetzte Richtung:   $$-\\vec{v} = \\begin{pmatrix} -v_x \\\\ -v_y \\end{pmatrix}, \\quad \\vec{BA} = -\\vec{AB}$$ - **3. Vektoraddition (Komponentenweise Addition)**:   * Entspricht der geometrischen Aneinanderreihung zweier Verschiebungen (Schaft des zweiten Pfeils an Spitze des ersten Pfeils):   $$\\vec{u} + \\vec{w} = \\begin{pmatrix} u_x \\\\ u_y \\end{pmatrix} + \\begin{pmatrix} w_x \\\\ w_y \\end{pmatrix} = \\begin{pmatrix} u_x + w_x \\\\ u_y + w_y \\end{pmatrix}$$ 3. Durchrechnung der Aufgabenstellungen: - **Berechnung des verschobenen Bildpunkts $P'$**:   $$\\vec{OP'} = \\vec{OP} \\oplus \\vec{v} = \\begin{pmatrix} -3 \\\\ 4 \\end{pmatrix} + \\begin{pmatrix} 6 \\\\ -2 \\end{pmatrix} = \\begin{pmatrix} -3+6 \\\\ 4-2 \\end{pmatrix} = \\begin{pmatrix} 3 \\\\ 2 \\end{pmatrix} \\implies \\mathbf{P'(3 \\mid 2)}$$ - **Berechnung des Summenvektors $\\vec{s} = \\vec{v} + \\vec{w}$**:   $$\\vec{s} = \\begin{pmatrix} 6 \\\\ -2 \\end{pmatrix} + \\begin{pmatrix} -1 \\\\ 5 \\end{pmatrix} = \\begin{pmatrix} 6 + (-1) \\\\ -2 + 5 \\end{pmatrix} = \\mathbf{\\begin{pmatrix} 5 \\\\ 3 \\end{pmatrix}}$$"
        }
      ]
    }
  ]
}
